import { httpService } from '@/services/HttpService';

class PublicIPAddressService {
  getPublicIPAddresses(workspaceId: number, regionId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/public_ip_addresses`);
  }
  getPublicIPAddress(workspaceId: number, regionId: number, publicIpAddressId: number): Promise<any> {
    return httpService.get(`workspaces/${workspaceId}/regions/${regionId}/public_ip_addresses/${publicIpAddressId}`);
  }
  reservePublicIPAddress(workspaceId: number, regionId: number): Promise<any> {
    return httpService.post(`workspaces/${workspaceId}/regions/${regionId}/public_ip_addresses`, '');
  }
  removePublicIPAddress(workspaceId: number, regionId: number, publicIpAddressId: number): Promise<any> {
    return httpService.delete(
      `workspaces/${workspaceId}/regions/${regionId}/public_ip_addresses/${publicIpAddressId}/resign`,
      ''
    );
  }
}

export const publicIPAddressService = new PublicIPAddressService();
